import { reqRightsDisplay } from '~/api';
import type { TRightDisplay } from '~/api/interface';

export const useDisplayRights = async (forceFetch?: boolean) => {
  const state = useState<TRightDisplay | null>('rights', () => null);
  if (state.value && !forceFetch) {
    return state;
  }
  const result = await reqRightsDisplay({ faq: true });
  state.value = result.data || null;
  return state;
};
